webpackJsonp([27],{

/***/ 1487:
/***/ (function(module, exports) {

MOVE.MORTGAGE.CONSTANTS = function () {

  var VU_VIDEO_TITLE = 'Brad Barr, Air Force Veteran and Proud Homeowner';

  MOVE.MORTGAGE.CONSTANTS = {
    VU_VIDEO_TITLE: VU_VIDEO_TITLE
  };
  return MOVE.FormatHelper.constantize(MOVE.MORTGAGE.CONSTANTS);
}();

/***/ }),

/***/ 1506:
/***/ (function(module, exports) {

MOVE.MORTGAGE.VULOAD = function (MORTGAGE) {
  var loadVideoLibrary = function loadVideoLibrary() {
    MOVE.DOMHelper.loadAsyncLib('//content.jwplatform.com/libraries/Frev7kSL.js');
  };

  var init = function init() {
    loadVideoLibrary();
  };

  MORTGAGE.VULOAD = {
    init: init
  };

  return MORTGAGE.VULOAD;
}(MOVE.MORTGAGE || {});

if (MOVE.DataStore.getData('controllerName') === 'veteran_loans') {
  MOVE.MORTGAGE.VULOAD.init();
}

/***/ }),

/***/ 1660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__application_critical__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_critical_bootstrap__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mortgage_mortgage__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mortgage_constants__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mortgage_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mortgage_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mortgage_vuload__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mortgage_vuload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mortgage_vuload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_critical_user_activity__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_critical_user_activity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_critical_user_activity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_app__);








/***/ }),

/***/ 19:
/***/ (function(module, exports) {

(function () {

    //bootstrap application
    MOVE.init();
})();

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__ = __webpack_require__(35);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



MOVE.MORTGAGE = function (MOVE) {
  var query_vars = null;
  var getQueryValue = function getQueryValue(query_key) {

    if (query_vars === null) {
      query_vars = getUrlVars();
    }

    var query_value = '';
    if (query_vars !== null) {
      if (query_vars[query_key] !== null) {
        query_value = query_vars[query_key];
      }
    }

    return query_value;
  };

  var getDevicePrefix = function getDevicePrefix(MOVE_DATA) {
    if (MOVE_DATA.isDesktop) {
      return 'web_';
    } else if (MOVE_DATA.isTablet) {
      return 'tabletw_';
    } else if (MOVE_DATA.isPhone) {
      return 'mobilew_';
    } else {
      return false;
    }
  };

  var getUrlVars = function getUrlVars() {
    var location = window.location;
    var queryParams = location.search.slice(1).replace(/[#?]/g, '&').split('&').map(function (p) {
      return p.split('=');
    }).reduce(function (obj, pair) {
      if (pair.length !== 2) return obj;
      try {
        var _pair$map = pair.map(decodeURIComponent),
            _pair$map2 = _slicedToArray(_pair$map, 2),
            key = _pair$map2[0],
            value = _pair$map2[1];

        obj[key] = value.replace(/\//g, '');
      } catch (e) {
        return obj;
      }
      return obj;
    }, {});

    var hashParams = location.hash.slice(1).replace(/[#?]/g, '&').split('&').map(function (p) {
      return p.split('=');
    }).reduce(function (obj, pair) {
      if (pair.length !== 2) return obj;
      try {
        var _pair$map3 = pair.map(decodeURIComponent),
            _pair$map4 = _slicedToArray(_pair$map3, 2),
            key = _pair$map4[0],
            value = _pair$map4[1];

        obj[key] = value.replace(/\//g, '');
      } catch (e) {
        return obj;
      }
      return obj;
    }, {});

    var vars = $.extend({}, queryParams, hashParams);
    return vars;
  };

  var validateRange = function validateRange(val, min, max) {

    if (val === null || val === undefined || isNaN(val) || val < min) {
      val = min;
    } else if (val > max) {
      val = max;
    }

    return val;
  };

  var rateFormatter = function rateFormatter(rate) {
    return rate.toFixed(3) + '%';
  };

  var moneyFormatter = function moneyFormatter(n) {
    var money = n.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    money = money.split('.');
    return money[0];
  };

  var removePercentage = function removePercentage(field) {

    if (field && field.val()) {
      return parseFloat(field.val().replace('%', ''));
    }

    return null;
  };

  var removeDollarCommas = function removeDollarCommas(field) {

    if (field && field.val()) {
      return parseInt(field.val().replace(/\$|,/g, ''), 10);
    }

    return null;
  };

  var addDollarCommas = function addDollarCommas(nStr) {
    return "$" + addCommas(nStr);
  };

  var addCommas = function addCommas(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  };

  var handleReturnAndTabKey = function handleReturnAndTabKey(keycode, event, callback) {
    if (keycode === __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__["a" /* ENTER_KEY */] || keycode === __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__["k" /* TAB_KEY */]) {
      $(event.target).trigger("change");
      if (keycode === __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__["a" /* ENTER_KEY */] && typeof callback === 'function') {
        callback(event);
      }
      return true;
    }
    return false;
  };

  var isNumber = function isNumber(keycode) {
    return keycode >= __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__["l" /* ZERO_KEY */] && keycode <= __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__["m" /* NINE_KEY */];
  };

  var isArrow = function isArrow(keycode) {
    return keycode === __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__["i" /* LEFT_KEY */] || keycode === __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__["j" /* RIGHT_KEY */];
  };

  var isTabOrBackSpace = function isTabOrBackSpace(keycode) {
    //"8" is for checking backspace, "9" for tab
    return keycode === __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__["e" /* BACKSPACE_KEY */] || keycode === __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__["k" /* TAB_KEY */] || keycode === 0;
  };

  var checkDecimalPoint = function checkDecimalPoint(event) {
    // In FF keycode 46 is for delete or decimal point, if event.keyCode it is delete, otherwise decimal point
    // In IE keycode 46 is decimal point, and delete key not get trapped by keypress event
    var isFF = /firefox/i.test(navigator.userAgent);
    if (!isFF) {
      return event.target.value.split('.').length === 1;
    } else {
      if (event.keyCode && event.keyCode > 0) {
        return true;
      } else {
        return event.target.value.split('.').length === 1;
      }
    }
  };

  var checkArrow = function checkArrow(event) {
    if (event.keyCode && event.keyCode > 0) {
      return !event.shiftKey;
    }
    return false;
  };

  var formatCurrency = function formatCurrency() {
    var $this = $(this);

    if (event.which === __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__["a" /* ENTER_KEY */]) fireChangeEvent(event);
    if (!checkNumeric(event) && !event.which == __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__["e" /* BACKSPACE_KEY */]) return;

    var value = $this.val();
    var newValue = "$" + value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    $this.val(newValue).addClass('changed');
    return true;
  };

  var checkNumeric = function checkNumeric(event) {
    return event.which >= __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__["l" /* ZERO_KEY */] && event.which <= __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__["m" /* NINE_KEY */];
  };

  // IE/iPad support for formatCurrency on keyup
  var monitorTouchEndForPriceInputs = function monitorTouchEndForPriceInputs() {
    $(document, '.page-content').on('mousedown touchend', function () {
      $('.price-input input').each(fireChangeEvent);
    });
  };

  var fireChangeEvent = function fireChangeEvent(e) {
    var $this = $(this);

    if (e && $(e.target).is('input')) {
      $this = $(e.target);
    }

    if ($this.hasClass('changed')) {
      $this.trigger('change');
      $this.removeClass('changed');
    }
  };

  var restrictNumbersOnly = function restrictNumbersOnly(event, callback) {
    return restrictUserInput(event, callback, true, false, false, false, false, false);
  };

  var restrictNumbersAndDecimalPointOnly = function restrictNumbersAndDecimalPointOnly(event, callback) {
    return restrictUserInput(event, callback, true, false, false, false, false, true);
  };

  var restrictNumbersAndDecimalPointAndNegativeOnly = function restrictNumbersAndDecimalPointAndNegativeOnly(event, callback) {
    return restrictUserInput(event, callback, true, false, false, true, false, true);
  };

  var restrictNumAlphabetOnly = function restrictNumAlphabetOnly(event, callback) {
    return restrictUserInput(event, callback, true, true, true, true, true, true);
  };

  var restrictUserInput = function restrictUserInput(event, callback, acceptNumber, acceptAlphabet, acceptComma, acceptHyphen, acceptSpace, acceptPoint) {
    var keycode = event.which ? event.which : event.keyCode;
    if (handleReturnAndTabKey(keycode, event, callback)) {
      return true;
    }

    //left, right arrows
    if (isArrow(keycode)) {
      return checkArrow(event);
    }

    if (acceptNumber) {
      if (isNumber(keycode)) // numbers
        {
          return true;
        }
    }

    if (acceptAlphabet) {
      if (keycode >= 65 && keycode <= 90) {
        // a - z
        return true;
      }
      if (keycode >= 97 && keycode <= 122) {
        // a - z
        return true;
      }
    }

    if (acceptComma) {
      if (keycode === 44) {
        //comma
        return true;
      }
    }

    if (acceptHyphen) {
      if (keycode === 45) {
        // "-"
        return event.target.selectionStart === 0;
      }
    }

    if (acceptSpace) {
      if (keycode === 32) {
        //space
        return true;
      }
    }

    if (acceptPoint) {
      if (keycode === __WEBPACK_IMPORTED_MODULE_0__shared_critical_constants_keys__["f" /* DELETE_KEY */]) {
        return checkDecimalPoint(event);
      }
    }

    return isTabOrBackSpace(keycode);
  };

  var getSearchLocation = function getSearchLocation() {
    var lastSearch = '';
    var recentSearches = MOVE.UserActivity.getRecentSearches();
    if (recentSearches && recentSearches.length > 0) {
      var lastSearchQuery = recentSearches[recentSearches.length - 1].query;
      if (lastSearchQuery.postal_code) {
        lastSearch = lastSearchQuery.postal_code;
      } else {
        if (lastSearchQuery.city && lastSearchQuery.state_code) {
          lastSearch = lastSearchQuery.city + ',' + lastSearchQuery.state_code;
        }
      }
    }
    return lastSearch;
  };

  var saveLocationToLocalStorage = function saveLocationToLocalStorage(location) {
    if (MOVE.UserActivity === undefined || location === undefined || location.indexOf(',') <= 0) {
      return;
    }
    var address = location.split(','),
        data = {};
    if (address.length === 3) {
      data['searchType'] = 'postal_code';
      data['zip'] = address[0];
      data['city'] = address[1];
      data['state_code'] = address[2];
    } else {
      data['searchType'] = 'city';
      data['zip'] = '';
      data['city'] = address[0];
      data['state_code'] = address[1];
    }

    // Update recent search
    if (data.city !== undefined && data.state_code !== undefined) {
      MOVE.UserActivity.updateRecentSearches({
        searchType: "mortgage",
        criteria: { postal: data.zip, city: data.city.trim(), state: data.state_code.trim(), searchType: data.searchType }
      }, false);
    }
  };

  var locationControlAutoCompleteSetup = function locationControlAutoCompleteSetup(locationBox, successCallback, includeZip) {
    var options = {
      validate_geo: {
        slug_prefix: MOVE.CONSTANTS.RDC_URL_STEMS.MORTGAGE
      },
      autocomplete_suggest: {
        area_types: 'city,postal_code'
      },
      includeZip: includeZip,
      validateSuccessCallback: function validateSuccessCallback(options) {
        saveLocationToLocalStorage(options.location);
        var expiration = MOVE.Helper.setCookieExpiry(60 * 24 * 30);
        $.cookie('HF_location', options.slug, { path: '/', expires: expiration });
        if (successCallback) {
          successCallback(options.location, options.zip, options.city, options.state);
        }
      },
      validateSearchCriteriaCallback: function validateSearchCriteriaCallback() {
        var searchCriteria = locationBox.val();
        var invalid = searchCriteria.match(/^([0-9]+)\ +([a-z]*)$/ig); // ex '128 parkville' ( for addresses)
        return !invalid;
      },
      placeholderText: "Please Enter a City or Zip Code"
    };

    MOVE.AutoComplete.init(locationBox, null, false, options);
  };

  var trackClick = function trackClick(context) {
    $('[' + 'data-omtag' + ']', context).click(function (event) {
      var tag = event.currentTarget.getAttribute('data-omtag');
      if (!tag) return;
      RdcTracking.trackEvent('click', { linkName: tag });
    });
  };

  MOVE.MORTGAGE = {
    addCommas: addCommas,
    getUrlVars: getUrlVars,
    getQueryValue: getQueryValue,
    validateRange: validateRange,
    addDollarCommas: addDollarCommas,
    removeDollarCommas: removeDollarCommas,
    formatCurrency: formatCurrency,
    monitorTouchEndForPriceInputs: monitorTouchEndForPriceInputs,
    fireChangeEvent: fireChangeEvent,
    removePercentage: removePercentage,
    moneyFormatter: moneyFormatter,
    rateFormatter: rateFormatter,
    getSearchLocation: getSearchLocation,
    saveLocationToLocalStorage: saveLocationToLocalStorage,
    locationControlAutoCompleteSetup: locationControlAutoCompleteSetup,
    restrictNumbersOnly: restrictNumbersOnly,
    restrictNumbersAndDecimalPointOnly: restrictNumbersAndDecimalPointOnly,
    restrictNumbersAndDecimalPointAndNegativeOnly: restrictNumbersAndDecimalPointAndNegativeOnly,
    restrictNumAlphabetOnly: restrictNumAlphabetOnly,
    getDevicePrefix: getDevicePrefix,
    trackClick: trackClick
  };

  return MOVE.MORTGAGE;
}(MOVE || {});

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_js_tooltip__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_js_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_js_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_js_popover__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_js_popover__);



/***/ }),

/***/ 96:
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: popover.js v3.3.2
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.2'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }

  Popover.prototype.tip = function () {
    if (!this.$tip) this.$tip = $(this.options.template)
    return this.$tip
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && option == 'destroy') return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);


/***/ }),

/***/ 97:
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: tooltip.js v3.3.2
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       =
    this.options    =
    this.enabled    =
    this.timeout    =
    this.hoverState =
    this.$element   = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.2'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $(this.options.viewport.selector || this.options.viewport)

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (self && self.$tip && self.$tip.is(':visible')) {
      self.hoverState = 'in'
      return
    }

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var $container   = this.options.container ? $(this.options.container) : this.$element.parent()
        var containerDim = this.getPosition($container)

        placement = placement == 'bottom' && pos.bottom + actualHeight > containerDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < containerDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > containerDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < containerDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  = offset.top  + marginTop
    offset.left = offset.left + marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isHorizontal) {
    this.arrow()
      .css(isHorizontal ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isHorizontal ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = this.tip()
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      that.$element
        .removeAttr('aria-describedby')
        .trigger('hidden.bs.' + that.type)
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && this.$tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof ($e.attr('data-original-title')) != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var elOffset  = isBody ? { top: 0, left: 0 } : $element.offset()
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.width) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    return (this.$tip = this.$tip || $(this.options.template))
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && option == 'destroy') return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);


/***/ })

},[1660]);


// WEBPACK FOOTER //
// mortgage_critical-b5770bdb23e88d1e8135.js